import React from 'react';
import { useTranslate } from '../../../../../customHooks';
import StatusDisplay from './StatusDisplay';

interface EnabledStatusProps {
    isEnabled: boolean;
    styles: any;
}

const EnabledStatus: React.FC<EnabledStatusProps> = ({ isEnabled, styles }) => {
    const translate = useTranslate();

    return (
        <span className={styles.flexRowValues}>
            <StatusDisplay
                status={isEnabled ? 'enabled' : 'disabled'}
                text={isEnabled ? translate('generic.yes') : translate('generic.no')}
            />
        </span>
    );
};

export default EnabledStatus;
